import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

const routes = [
  {
    path: 'contracts',
    name: 'admin-contracts',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.contracts],
      module: ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
    },
    component: () =>
      import(/* webpackChunkName: "admin-contracts" */ '@contracts/pages/contract/contract.vue'),
  },
];

export default routes;
